export default {"src":"/_next/static/media/team.b4ff723d.svg","height":13,"width":10,"blurWidth":0,"blurHeight":0};